export const HOST = '';
// export const HOST = 'https://vserpdp.customer-portal.biz';

export const VALIDATE_TOKEN = 'api/admin/login';
export const POST_NEW_ACCOUNT = '/api/account/register';
export const POST_RESET_PASSWORD_FORM = '/api/account/forgotpassword';
export const POST_RESET_PASSWORD = '/api/account/resetpassword';
export const POST_REQUEST_ACCOUNT = '/api/account/requestuser';

export const SALESPERSON_AR_API = '/api/salesperson';
export const FETCH_SALESPERSON_LIST = '/erp/salesperson/customers';

export const FETCH_HEADER_INFO = '/api/merchant/headerfooter';
export const FETCH_POPUP_API = '/erp/account/popupcomment';
export const PUT_POPUP_DISMISS = '/erp/account/disablepopup';

export const GET_BROADCAST_DATE = '/api/account/GetBroadcastReadDate';
export const SET_BROADCAST_DATE = '/api/account/SetBroadcastReadDate';

export const CUSTOMER_ACTIVITY_API = '/erp/customer/customeractivity';
export const CUSTOMER_INFO_API = '/erp/customer/customerinfo';

export const FETCH_TRANSACTIONS_API = '/erp/customer/transactions';
export const FETCH_TRANSACTION_SETTINGS_API = '/erp/customer/viewtransactionsettings';
export const FETCH_TRANSACTION_UPDATE_DATE = '/erp/customer/GetLatestDocumentDate';

export const FETCH_ORDERS_LIST_API = '/erp/customer/orders';
export const FETCH_ORDERS_DETAILS = '/erp/customer/orderDetails';
export const FETCH_ORDERS_ITEM_API = '/erp/customer/backorderitems';
export const FETCH_ORDERS_SETTINGS_API = '/erp/customer/viewordersettings';
export const FETCH_ORDERS_UPDATE_DATE = '/erp/customer/GetLatestOrderDate';
export const FETCH_DRILLDOWN_TO_INVOICE = '/erp/customer/InvoicesFromOrder';
export const FETCH_DRILLDOWN_FROM_QUOTE = '/erp/customer/quoteorder';
export const FETCH_QUOTE_TO_ORDER = '/erp/customer/QuoteToOrder';
export const FETCH_DOCUMENT_DRILLDOWN = '/erp/customer/DocumentDrilldown';

export const FETCH_DOC_DETAILS_AR_API = '/erp/customer/ardocumentdetails';
export const FETCH_DOC_DETAILS_OE_API = '/erp/customer/oedocumentdetails';
export const FETCH_DOC_DETAILS_FWLTC_API = '/erp/frameworkltc/invoice';
export const FETCH_DOC_DETAILS_CUSTOM_API = '/api/customizations';

export const FETCH_DOC_MERCHANT_API = '/api/merchant/billinginfo/';

export const FETCH_PAY_ACCOUNT_INFO = '/erp/customer/viewpayaccount';
export const FETCH_PAY_ACCOUNT_DETAILS = '/erp/customer/viewpayaccountdetails';
export const GET_PAYMENT_SETTING = '/erp/customer/paymentsettings';
export const PAYMENT_CARDS_API = '/api/customer/storedpaymentinfo';

export const FETCH_CONTACT_INFO_API = '/erp/user/contactusinfo';
export const SEND_CONTACT_WITHOUT_LOGIN = '/erp/customer/contactus';
export const POST_CONTACT_API = '/erp/customer/contactus';

export const MY_ACCOUNT_API = '/api/account/';
export const POST_PASSWORD_API = '/api/account/changepassword';

export const FETCH_PAYMENT_INVOICE_INFO = '/erp/customer/document';
export const POST_PAYMENT_INVOICE = '/erp/customer/quickpay';
export const FETCH_INVOICE_RECEIPT_INFO = '/erp/';
export const FETCH_TRANSACTION_INFO = '/api/transaction';

export const GET_CUSTOMIZATION = '/api/Customizations';

export const PAYPAL_CREDENTIALS = '/api/paypal/clientcredentials';
export const PAYPAL_CREATE_ORDER = '/api/paypal/createorder';
export const PAYPAL_COMPELETE_ORDER = '/api/paypal/approve';
export const PAYPAL_TRANSACTION_ERROR = '/api/paypal/error';